import React from 'react';
import Layout from './Layout';
import SEO from './SEO';

const Default = () => (
  <>
    <SEO title="Result" />
    <h1>This is result page</h1>
  </>
);

export default Default;
